import styled from 'styled-components';
import {defaultTheme, textSizes} from '@stencil/build-theme';

import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const FlexItemCenter = styled.div(
  props => `
          display:flex;
          align-items: ${props.alignitem || 'center'};
          `,
);

export const BookingWidgetStyleContainer = styled.div(
  props => `
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    background-color: #fff0eb;
    border: solid 1px #ffe2d8;
    margin-bottom:${props.theme.spacing.base};
    display:flex;
    flex-direction: column;
  `,
);

export const MultiRoomDetailWrapperDiv = styled.div(
  props => `
    display:flex;
    flex-direction: row;
    width:100%;
    padding: ${props.theme.spacing.base};
    
  `,
);

export const BookNowSection = styled.div(
  props => `
    padding:${props.theme.spacing.custom(12)};
    border-top: 1px solid #ffe0d5;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
);

export const BookNowSectionText = styled.p(
  props => `
    font-size:${props.theme.font.custom(12)};
    font-weight: 600;
    color:  ${defaultTheme.colors.goBrandBlue.base};
  `,
);

export const BookNowButton = styled(ButtonBase)(
  props => `
    height:3.5rem;
      padding-left: ${props.theme.spacing.custom(17)};
    padding-right: ${props.theme.spacing.custom(17)};
    border-radius: 1.7rem;
    border: solid 0.2rem ${props.theme.colors.goBrandOrange.medium};
    text-transform: none;
  `,
);

export const ViewRoomOptionsButton = styled(PrimaryLink)`
  display: flex;
  align-items: center;
`;

export const RightDoubleArrowIconContainer = styled.div(
  props => `
    transform: rotate(90deg);
    display: inline-block;
    position: relative;
    top: 0.2rem;
    margin-left: ${props.theme.spacing.custom(4)};
  `,
);

export const MultiRoomDetailLeftPara = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    width:65%;
  `,
);

export const MultiRoomDetailRightPara = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    width:35%;
    align-items: flex-end;
    justify-content: flex-end;
  `,
);

export const PaxCountSpan = styled.span(
  props => `
    font-size:${props.theme.font.base};
    color:${props.theme.colors.ash.base};
    padding-bottom: ${props.theme.spacing.base};
    `,
);

export const FirstPropertyTypeSpan = styled.span(
  props => `
    font-size:${props.theme.font.base};
    font-weight: 600;
    padding-bottom: ${props.paddingBottom ? props.paddingBottom : props.theme.spacing.base};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width:85%;
    // margin-left:0.5rem;
    `,
);

export const SecondPropertyTypeSpan = styled.span(
  props => `
    font-size:${props.theme.font.base};
    font-weight: 600;
    padding-bottom: ${props.theme.spacing.base};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width:75%;
    border-bottom: 1px solid #ffe2d8;
    `,
);

export const AminitiesProvidedPara = styled(FlexItemCenter)(
  props => `
    padding-top:${props.theme.spacing.base};
    padding-bottom: ${props.theme.spacing.base};
    `,
);

export const RoundedCircle = styled.span(
  props => `
    width:1rem;
    height:1rem;
    border-radius:50%;
    margin-right: ${props.theme.spacing.small};
    flex-shrink:0;
    background:${props.theme.colors.goRed.base};
    color:white;
    font-size:14px;
    align-items: center;
    justify-content: center;
    display: flex;
    // padding-left: 1px;
    text-align:center;
    padding-bottom:2px;
    `,
);

export const AlertTextSpan = styled.span(
  props => `
    // color:${props.theme.colors.goRed.base};
    // margin-left:0.5rem;
    `,
);

export const StrickedPricePara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    color: ${props.theme.colors.ash.base};
    text-decoration: line-through;
    `,
);

export const OriginalPricePara = styled.p`
  ${textSizes.MediumW3}
  padding-bottom: ${props => props.theme.spacing.small};
`;

export const TaxInclusionPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(10)};
    padding-bottom: ${props.theme.spacing.small};
    `,
);

export const RoomsAvailablePara = styled.p(
  props => `
    color: ${props.theme.colors.ash.base};
    margin-left: 2rem;
  `,
);
